import { render } from "./ProjectDescription.vue?vue&type=template&id=13fa6f2e"
import script from "./ProjectDescription.vue?vue&type=script&lang=js"
export * from "./ProjectDescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__